// extracted by mini-css-extract-plugin
export default {"mainContainer":"ChangeTypeModal_mainContainer__hOzbu"};